import React from "react";

const SimpliestFooter = () => {
  return (
    <footer className="footer">
      <div className="container content !py-5">
        <p className="text-center text-[11px] max-w-[800px]">
          As informações aqui dispostas são material sensível e sigiloso, destinadas para fins estritamente comerciais e
          nunca deverão ser utilizadas para fins ilícitos. Estão proibidas cópia, impressão, foto, gravação de tela ou
          qualquer tipo de reprodução deste material. E o compartilhamento indevido destes dados é expressamente
          proibido e configura causa para desligamento imediato.
        </p>
      </div>
    </footer>
  );
};

export default SimpliestFooter;
